import { FILTER_CATEGORIES_CONFIG } from '@resources/js/components/filters/filterCategoriesConfig';
// чи однаковий набір значень, без урахування порядку
export const isSameValues = (first, second) => first.length === second.length && first.every(value => second.includes(value));
// приводить рядкові id фільтрів з URL до чисел
export const parseFiltersFromString = (rawFilterParams) => {
    const filtersState = {};
    for (const category in rawFilterParams) {
        filtersState[category] = rawFilterParams[category].map(Number);
    }
    return filtersState;
};
// вписує стан фільтрів у query-рядок,
// не чіпаючи параметри, що не належать до фільтрів (ab-test, utm тощо)
export const buildFiltersQuery = (search, filtersState) => {
    var _a;
    const searchParams = new URLSearchParams(search);
    const searchKeys = [...new Set(searchParams.keys())];
    for (const category of Object.keys(FILTER_CATEGORIES_CONFIG)) {
        // потрібно видаляти ключі категорії в обох форматах: themes[] і індексований themes[0]
        const categoryKeyPattern = new RegExp(`^${category}\\[\\d*\\]$`);
        // знаходимо всі ключі категорії з URL і видаляємо їх разом зі значеннями
        searchKeys
            .filter(key => categoryKeyPattern.test(key))
            .forEach(key => searchParams.delete(key));
        (_a = filtersState[category]) === null || _a === void 0 ? void 0 : _a.forEach(value => searchParams.append(`${category}[]`, String(value)));
    }
    return searchParams.toString();
};
// зчитує дані з JSON-скрипта, вставленого в Blade;
// null — якщо елемента немає або JSON битий
export const parseJsonScript = (elementId) => {
    const element = document.getElementById(elementId);
    if (!(element === null || element === void 0 ? void 0 : element.textContent))
        return null;
    try {
        return JSON.parse(element.textContent);
    }
    catch (_a) {
        return null;
    }
};
// зчитує перекладені назви категорій з JSON-скрипта, вставленого в Blade;
// без даних — порожній об'єкт, тоді категорії підписуються своїм ключем
export const parseCategoryLabels = (elementId) => { var _a; return (_a = parseJsonScript(elementId)) !== null && _a !== void 0 ? _a : {}; };
// дістає id усіх опцій по кожній категорії — довідник валідних значень для FiltersStore
export const getAvailableFilters = (filtersData) => {
    const availableFilters = {};
    for (const category in filtersData) {
        availableFilters[category] = filtersData[category].map(option => option.id);
    }
    return availableFilters;
};
// рахує загальну кількість обраних значень фільтрів по всіх категоріях
export const getSelectedFiltersCount = (filtersState) => {
    return Object.values(filtersState).reduce((count, values) => count + values.length, 0);
};
